import { useCallback } from "react";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../store";

export default function useFlightOfferInSearchResults() {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const flights = store.searchResults.flights;
  const brandedFaresStore = store.brandedFares.fareOffersWithDetails;

  const getTotalPrice = useCallback(
    (id?: string, baseOfferToken?: string) => {
      if (!id) return undefined;
      if (baseOfferToken) {
        // if baseOfferToken exists, then it is coming from branded fares in search. so match the id against list of
        // branded fare offers
        if (brandedFaresStore[baseOfferToken]) {
          const fares = brandedFaresStore[baseOfferToken];
          const priceExistsInBrandedFareOffer = fares.brandedFareOffers?.find((offer) => offer.token === id)
            ?.priceBreakdown?.total;
          if (priceExistsInBrandedFareOffer) return priceExistsInBrandedFareOffer;
        }
      }
      return flights.find((flight) => flight.token === id)?.priceBreakdown?.total;
    },
    [flights, brandedFaresStore]
  );
  return { getTotalPrice };
}
